/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { environment } from 'environments/environment';
import {
    // configuration
    ORGANIZATION_PREFERENCE_ACCESS,
    FAQ_ACCESS,
    APP_UPDATE_ACCESS,
    STUDENT_FORM_ACCESS,
    WEB_PREFERENCE_ACCESS,
    BANNERS_ACCESS,

    // user
    CLIENTS,
    STUDENT_ACCESS,
    TEACHER_ACCESS,
    PARENT_ACCESS,
    VIRTUAL_USER_MAPPING,
    SUBSCRIBER_ACCESS,
    PW_CLIENT_S2S,
    LCM_ACCESS,

    // application
    ANALYTICS_ACCESS,
    PROGRAM_ACCESS,
    MCQ_ACCESS,
    COMPANY_ACCESS,
    STATE_ACCESS,
    ADMISSION_YEARS_ACCESS,
    SUBJECT_EXPERTISE,

    // management
    BATCH_CATEGORY_ACCESS,
    STUDY_MATERIAL_ACCESS,
    BHARAT_VIDEO_ACCESS,
    BATCH_MENTORS_ACCESS,
    MARGDARSHAK,
    COHORT_ACCESS,
    DOUBT_CATEGORY_ACCESS,
    ORDER_ACCESS,
    ORDER_CANCELLATION_ACCESS,
    REPORT_ACCESS,
    SAARTHI_ACCESS,
    TESTIMONIAL_ACCESS,
    ORG_ANNOUNCEMENTS_ACCESS,
    TEST_PASS,
    THREE_D_MODEL_ACCESS,
    SLIDE_IMAGE_ACCESS,
    COHORT_EVENT_ACCESS,

    // batch-automation,
    BATCH_ACCESS,

    // video-player
    ORGANIZATION_PREFERENCE_VIDEO_ACCESS,
    ANIMATIONS,
    BADGES,

    // videos
    DRIVE_SECURE_BULK_ACCESS,
    PENPENCIL_VIDEO_ACCESS,
    LIVE_STREAM_ACCESS,
    REELS,
    WEBINAR_UNIGO,

    // studio
    STUDIO_ACCESS,
    STUDIO_LOCATIONS,

    // feed
    FEEDS_ACCESS,

    // books
    EXAM_ACCESS,
    BOOK_CATEGORY_ACCESS,
    AUTHOR_ACCESS,
    PUBLICATION_ACCESS,
    BOOK_TAGS_ACCESS,
    DELIVERY_PIN_CODE_ACCESS,
    BOOK_ACCESS,

    // promotions
    NEWS_AND_BLOGS_ACCESS,
    JOB_ALERT,
    REWARD,
    COUPON_ACCESS,
    BULK_COUPON_ACCESS,

    // offline-centre
    OFFLINE_CATEGORY,
    PATHSHALA_CENTER_ACCESS,
    RFID_MACHINE_ACCESS,
    EVAL_DASHBOARD_ACCESS,
    SCHOLARSHIP_ACCESS,
    SAT_CATAGORY,
    WEBINAR_ACCESS,

    // sst
    REPORT_TAGS_ACCESS,
    HELPCENTER_ACCESS,
    SOURCE_FLOWS_ACCESS,
    USER_GROUPS_ACCESS,
    NOTICE_ACCESS,

    // engagement
    COACH_MARK,
    BATTLEGROUND_ACCESS,
    COMMUNITY_ACCESS,
    LIBRARY_REVAMP_ACCESS,
    LEVEL_UP_ACCESS,
    AI_NCERT_ACCESS,

    // loan-buddies
    LOAN_BUDDY,
    BANK,

    // External
    SDUI_ACCESS,
    BATCH_MULTI_ACCESS,
    NUGGETS_ACCESS,
    PW_TALK_ACCESS,
    OTT_VIDEO,
    OTT_PLAYLIST,
    OTT_TEACHER,
    OTT_BULK_UPLOAD,
    OTT_SUBSCRIPTION,
    ONBOARDING_LAYER_ACCESS,
    JOBS_ACCESS,
    OTT_BROWSE,
    META_ACCESS,
    BANNER_PACKAGE,
} from 'app/core/constants';
import { EXTERNAL_NAVIGATION } from './util';

const isYcmouOrg = (): boolean => {
    try {
        const user = JSON.parse(localStorage.getItem('user') ?? '{}');
        return user?.organization?._id === environment.orgIds.ycmou;
    } catch {
        return false;
    }
};

const isYcmouMentor = (): boolean => {
    try {
        const user = JSON.parse(localStorage.getItem('user') ?? '{}');
        return Array.isArray(user?.roles)
            ? user.roles.some(
                  (role) =>
                      role?.name === 'YCMOU_MENTOR' || role?.name === 'Teacher',
              )
            : false;
    } catch {
        return false;
    }
};

const configurationRoutes: FuseNavigationItem[] = [
    {
        id: 'profile',
        title: 'Profile',
        type: 'basic',
        icon: 'person',
        link: 'profile',
        permission: 'all',
    },
    {
        id: 'preferences',
        title: 'Preferences',
        type: 'basic',
        icon: 'room_preferences',
        hidden: () => isYcmouOrg(),
        link: 'preferences',
        permission: ORGANIZATION_PREFERENCE_ACCESS.list,
    },
    // {
    //     id: 'faq-category',
    //     title: 'FAQ Category',
    //     type: 'basic',
    //     icon: 'quiz',
    //     link: 'faq-category',
    //     permission: FAQ_ACCESS.list,
    // },
    // {
    //     id: 'app-update',
    //     title: 'App Update',
    //     type: 'basic',
    //     icon: 'security_update_good',
    //     link: 'app-update',
    //     permission: APP_UPDATE_ACCESS.list,
    // },
    // {
    //     id: 'businessmodule',
    //     title: 'Business Module',
    //     type: 'basic',
    //     icon: 'cases',
    //     link: 'businessmodule',
    //     permission: ORGANIZATION_PREFERENCE_ACCESS.business_list,
    // },
    // {
    //     id: 'student-form',
    //     title: 'Student Form',
    //     type: 'basic',
    //     icon: 'settings_accessibility',
    //     link: 'student-form',
    //     permission: STUDENT_FORM_ACCESS.list,
    // },
    // {
    //     id: 'webpage',
    //     title: 'Web Home',
    //     type: 'basic',
    //     icon: 'language',
    //     link: 'webpage',
    //     permission: WEB_PREFERENCE_ACCESS.list,
    // },
    // {
    //     id: 'web-preference',
    //     title: 'Web Preference',
    //     type: 'basic',
    //     icon: 'language',
    //     link: 'web-preference',
    //     permission: WEB_PREFERENCE_ACCESS.list,
    // },
    // {
    //     id: 'banners',
    //     title: 'Banners',
    //     type: 'basic',
    //     icon: 'preview',
    //     link: 'banners',
    //     permission: BANNERS_ACCESS.list,
    // },
    // {
    //     id: 'banner-package',
    //     title: 'Banner Package',
    //     type: 'basic',
    //     icon: 'preview',
    //     link: 'banner-package',
    //     permission: BANNER_PACKAGE.list,
    // },
    // {
    //     id: 'thankyou',
    //     title: 'Thank You',
    //     type: 'basic',
    //     icon: 'heroicons_outline:chart-pie',
    //     link: 'thankyou',
    //     permission: WEB_PREFERENCE_ACCESS.list,
    // },
];

const userRoutes: FuseNavigationItem[] = [
    {
        id: 'clients',
        title: 'Clients',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: 'clients',
        permission: CLIENTS.list,
    },
    {
        id: 'users',
        title: 'All Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: 'users',
        permission: STUDENT_ACCESS.v2usersList,
    },
    {
        id: 'admin',
        title: 'Admin Users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: 'admins',
        permission: TEACHER_ACCESS.list,
    },
    {
        id: 'roles',
        title: 'Roles',
        type: 'basic',
        icon: 'heroicons_outline:user',
        link: 'roles',
        hidden: () => isYcmouMentor(),
        permission: 'all',
    },
    {
        id: 'teachers',
        title: 'Teachers',
        type: 'basic',
        icon: 'heroicons_outline:user-remove',
        link: 'teachers',
        permission: TEACHER_ACCESS.list,
    },
    {
        id: 'global-user-cms',
        title: 'Global User CMS',
        type: 'basic',
        icon: 'public',
        link: 'global-user-cms',
        hidden: () => isYcmouOrg(),
        permission: STUDENT_ACCESS.v2usersList,
    },
    // {
    //     id: 'gyaane-user-cms',
    //     title: 'Gyaane User CMS',
    //     type: 'basic',
    //     icon: 'public',
    //     link: 'gyaane-user-cms',
    //     permission: STUDENT_ACCESS.v2usersList,
    // },
    // {
    //     id: 'offline-centre-client',
    //     title: 'Offline Centre Client',
    //     type: 'basic',
    //     icon: 'public',
    //     link: 'offline-centre-client',
    //     permission: STUDENT_ACCESS.v2usersList,
    // },
    {
        id: 'students',
        title: 'Students',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: 'students',
        hidden: () => isYcmouMentor(),
        permission: STUDENT_ACCESS.list,
    },
    // {
    //     id: 'parents',
    //     title: 'Parents',
    //     type: 'basic',
    //     icon: 'heroicons_outline:emoji-happy',
    //     link: 'parents',
    //     permission: PARENT_ACCESS.list,
    // },
    // {
    //     id: 'qbg_users',
    //     title: 'QBG Users',
    //     type: 'basic',
    //     icon: 'heroicons_outline:library',
    //     link: 'qbg_users',
    //     permission: STUDENT_ACCESS.v2usersList,
    // },
    // {
    //     id: 'sst-agents',
    //     title: 'SST Users',
    //     type: 'basic',
    //     icon: 'heroicons_outline:information-circle',
    //     link: 'sst-agents',
    //     permission: STUDENT_ACCESS.v2usersList,
    // },
    {
        id: 'doubt-sme',
        title: 'Doubt SMEs',
        type: 'basic',
        icon: 'heroicons_outline:academic-cap',
        link: 'doubt-sme',
        permission: TEACHER_ACCESS.list,
    },
    {
        id: 'virtual-user-mapping',
        title: 'Virtual User Mapping',
        type: 'basic',
        icon: 'heroicons_outline:refresh',
        link: 'virtual-user-mapping',
        hidden: () => isYcmouOrg(),
        permission: VIRTUAL_USER_MAPPING.list,
    },
    // {
    //     id: 'subscribers',
    //     title: 'Subscribers',
    //     type: 'basic',
    //     icon: 'heroicons_outline:bell',
    //     link: 'subscribers',
    //     permission: SUBSCRIBER_ACCESS.list,
    // },
    // {
    //     id: 'pw-clients-s2s',
    //     title: 'PW Clients S2S',
    //     type: 'basic',
    //     icon: 'supervised_user_circle',
    //     link: 'pw-clients-s2s',
    //     permission: PW_CLIENT_S2S.list,
    // },
    {
        id: 'block-history',
        title: 'Block History',
        type: 'basic',
        icon: 'app_blocking',
        link: 'odyssey/block-history',
        hidden: () => isYcmouOrg(),
        permission: LCM_ACCESS.blockHistory,
    },
];

const applicationRoutes: FuseNavigationItem[] = [
    // {
    //     id: 'dashboard',
    //     title: 'Dashboard',
    //     type: 'basic',
    //     icon: 'leaderboard',
    //     link: 'dashboard',
    //     permission: ANALYTICS_ACCESS.list,
    // },
    {
        id: 'programs',
        title: 'Programs',
        type: 'basic',
        icon: 'event_note',
        link: 'programs',
        permission: PROGRAM_ACCESS.list,
    },
    // {
    //     id: 'daily-updates',
    //     title: 'Daily Updates',
    //     type: 'basic',
    //     icon: 'sync_alt',
    //     link: 'daily-updates',
    //     permission: MCQ_ACCESS.list,
    // },
    // {
    //     id: 'company-details',
    //     title: 'Company',
    //     type: 'basic',
    //     icon: 'corporate_fare',
    //     link: 'company-details',
    //     permission: COMPANY_ACCESS.list,
    // },
    // {
    //     id: 'state',
    //     title: 'State',
    //     type: 'basic',
    //     icon: 'cottage',
    //     link: 'state',
    //     permission: STATE_ACCESS.list,
    // },
    // {
    //     id: 'admission-years',
    //     title: 'Admission Years',
    //     type: 'basic',
    //     icon: 'heroicons_outline:calendar',
    //     link: 'admission-years',
    //     permission: ADMISSION_YEARS_ACCESS.list,
    // },
    // {
    //     id: 'subject-expertise',
    //     title: 'Subject Expertise',
    //     type: 'basic',
    //     icon: 'heroicons_outline:calendar',
    //     link: 'subject-expertise',
    //     permission: SUBJECT_EXPERTISE.list,
    // },
];

const managementRoutes: FuseNavigationItem[] = [
    {
        id: 'batch-category',
        title: 'Batch Category',
        type: 'basic',
        icon: 'badge',
        link: 'batch-category',
        permission: BATCH_CATEGORY_ACCESS.list,
    },

    // {
    //     id: 'bharat-video',
    //     title: 'Bharat Video',
    //     type: 'basic',
    //     icon: 'missed_video_call',
    //     link: 'bharat-video',
    //     permission: BHARAT_VIDEO_ACCESS.list,
    // },
    {
        id: 'batch-mentor',
        title: 'Mentors',
        type: 'basic',
        icon: 'support_agent',
        link: 'batch-mentors',
        permission: BATCH_MENTORS_ACCESS.list,
    },
    // {
    //     id: 'margdarshak',
    //     title: 'Margdarshak',
    //     type: 'basic',
    //     icon: 'community_side',
    //     link: 'margdarshak',
    //     permission: MARGDARSHAK.teacherList,
    // },

    {
        id: 'doubts-category',
        title: 'Doubts Category',
        type: 'basic',
        icon: 'travel_explore',
        link: 'doubts-category',
        permission: DOUBT_CATEGORY_ACCESS.list,
    },

    {
        id: 'doubts',
        title: 'Doubts',
        type: 'basic',
        icon: 'data_usage',
        link: 'doubts',
        permission: 'all',
    },

    // {
    //     id: 'orders',
    //     title: 'Orders',
    //     type: 'basic',
    //     icon: 'grading',
    //     link: 'orders',
    //     permission: ORDER_ACCESS.list,
    // },
    // {
    //     id: 'order-cancellation-requests',
    //     title: 'Order Cancellation Requests',
    //     type: 'basic',
    //     icon: 'free_cancellation',
    //     link: 'order-cancellation-requests',
    //     permission: ORDER_CANCELLATION_ACCESS.list,
    // },
    // {
    //     id: 'reports',
    //     title: 'Reports',
    //     type: 'basic',
    //     icon: 'border_color',
    //     link: 'reports',
    //     permission: REPORT_ACCESS.list,
    // },
    // {
    //     id: 'saarthi',
    //     title: 'Saarthi',
    //     type: 'basic',
    //     icon: 'bedroom_baby',
    //     link: 'saarthi',
    //     permission: SAARTHI_ACCESS.list,
    // },
    // {
    //     id: 'testimonial',
    //     title: 'Testimonial',
    //     type: 'basic',
    //     icon: 'document_scanner',
    //     link: 'testimonial',
    //     permission: TESTIMONIAL_ACCESS.list,
    // },
    // {
    //     id: 'org-announcements',
    //     title: 'Org Announcements',
    //     type: 'basic',
    //     icon: 'campaign',
    //     link: 'org-announcements',
    //     permission: ORG_ANNOUNCEMENTS_ACCESS.list,
    // },
    // {
    //     id: 'test-pass',
    //     title: 'Test Pass',
    //     type: 'basic',
    //     icon: 'pin',
    //     link: 'test-pass',
    //     permission: TEST_PASS.list,
    // },
    // {
    //     id: '3d-models',
    //     title: '3D Models',
    //     type: 'basic',
    //     icon: '3d_rotation',
    //     link: '3d-models',
    //     permission: THREE_D_MODEL_ACCESS.list,
    // },

    // {
    //     id: 'slide-image',
    //     title: 'Slide Image',
    //     type: 'basic',
    //     icon: 'image',
    //     link: 'slide-image',
    //     permission: SLIDE_IMAGE_ACCESS.list,
    // },
    // {
    //     id: 'deeplink-gen',
    //     title: 'Deeplink Gen',
    //     type: 'basic',
    //     icon: 'link',
    //     link: 'deeplink-gen',
    // },
];

const jobRoutes: FuseNavigationItem[] = [
    {
        id: 'job',
        title: 'Job',
        type: 'basic',
        icon: 'sort_by_alpha',
        link: 'job',
        permission: JOBS_ACCESS.getJobDetails,
    },
    {
        id: 'jobs-config',
        title: 'Jobs Config',
        type: 'basic',
        icon: 'settings',
        link: 'jobs-config',
        permission: JOBS_ACCESS.getJobConfig,
    },
];

const metaRoutes: FuseNavigationItem[] = [
    {
        id: 'meta-exam',
        title: 'Exam',
        type: 'basic',
        icon: 'description',
        link: 'meta-exam',
        permission: META_ACCESS.examList,
    },
    {
        id: 'meta-class',
        title: 'Class',
        type: 'basic',
        icon: 'description',
        link: 'meta-class',
        permission: META_ACCESS.classList,
    },
    {
        id: 'meta-board',
        title: 'Board',
        type: 'basic',
        icon: 'description',
        link: 'meta-board',
        permission: META_ACCESS.boardList,
    },
    {
        id: 'meta-language',
        title: 'Language',
        type: 'basic',
        icon: 'description',
        link: 'meta-language',
        permission: META_ACCESS.languageList,
    },
    {
        id: 'meta-stream',
        title: 'Stream',
        type: 'basic',
        icon: 'description',
        link: 'meta-stream',
        permission: META_ACCESS.streamList,
    },
    {
        id: 'meta-sub-exam',
        title: 'Sub Exam',
        type: 'basic',
        icon: 'description',
        link: 'meta-sub-exam',
        permission: META_ACCESS['sub-examList'],
    },
    {
        id: 'meta-exam-year',
        title: 'Exam Year',
        type: 'basic',
        icon: 'description',
        link: 'meta-exam-year',
        permission: META_ACCESS['exam-yearList'],
    },
    {
        id: 'meta-finance-exam-category',
        title: 'Finance Exam Category',
        type: 'basic',
        icon: 'description',
        link: 'meta-finance-exam-category',
        permission: META_ACCESS['finance-exam-categoryList'],
    },
];

const cohortRoutes: FuseNavigationItem[] = [
    {
        id: 'cohort',
        title: 'Cohort',
        type: 'basic',
        icon: 'sort_by_alpha',
        link: 'cohort',
        permission: COHORT_ACCESS.list,
    },
    // {
    //     id: 'cohort-events',
    //     title: 'Cohort Events',
    //     type: 'basic',
    //     icon: 'event',
    //     link: 'cohort-events',
    //     permission: COHORT_EVENT_ACCESS.list,
    // },
    // {
    //     id: 'onboarding-layer',
    //     title: 'Onboarding Layers',
    //     type: 'basic',
    //     icon: 'layers',
    //     link: 'onboarding-layer',
    //     permission: ONBOARDING_LAYER_ACCESS.rootListing,
    // },
    {
        id: 'meta',
        title: 'Meta',
        type: 'collapsable',
        icon: 'settings',
        children: metaRoutes,
    },
];

const batchAutomationRoutes: FuseNavigationItem[] = [
    {
        id: 'batch-automation-announcement',
        title: 'Announcement',
        type: 'basic',
        icon: 'alarm',
        link: 'batch-automation-announcement',
        permission: BATCH_ACCESS.addAnnouncement,
    },
    {
        id: 'batch-automation-homework',
        title: 'Homework',
        type: 'basic',
        icon: 'edit_note',
        link: 'batch-automation-homework',
        permission: BATCH_ACCESS.addHomework,
    },
];

const videoPlayerRoutes: FuseNavigationItem[] = [
    {
        id: 'video-player-quality',
        title: 'Configuration',
        type: 'basic',
        icon: 'heroicons_outline:cog',
        link: 'video-player-quality',
        permission: ORGANIZATION_PREFERENCE_VIDEO_ACCESS.list,
    },
    {
        id: 'animations',
        title: 'Animations',
        type: 'basic',
        icon: 'camera',
        link: 'animations',
        permission: ANIMATIONS.list,
    },
    {
        id: 'badges',
        title: 'Badges',
        type: 'basic',
        icon: 'heroicons_outline:gift',
        link: 'badges',
        permission: BADGES.list,
    },
    {
        id: 'automated-badges',
        title: 'Automated Badges',
        type: 'basic',
        icon: 'heroicons_outline:gift',
        link: 'automated-badges',
        permission: BADGES.list,
    },
    {
        id: 'automated-animations',
        title: 'Automated Animations',
        type: 'basic',
        icon: 'camera',
        link: 'automated-animations',
        permission: ANIMATIONS.list,
    },
];

const videosRoutes: FuseNavigationItem[] = [
    // {
    //     id: 'drive-secure-bulk',
    //     title: 'Drive To Secure Bulk',
    //     type: 'basic',
    //     icon: 'task',
    //     link: 'drive-secure-bulk',
    //     permission: DRIVE_SECURE_BULK_ACCESS.list,
    // },
    {
        id: 'videos-tags',
        title: 'Secure Videos',
        type: 'basic',
        icon: 'play_circle',
        link: 'videos-tags',
        permission: PENPENCIL_VIDEO_ACCESS.list,
    },
    // {
    //     id: 'secure-live',
    //     title: 'Secure Live',
    //     type: 'basic',
    //     icon: 'live_tv',
    //     link: 'secure-live',
    //     permission: LIVE_STREAM_ACCESS.fetch,
    // },
    // {
    //     id: 'secure-live-videos',
    //     title: 'Secure Live Videos',
    //     type: 'basic',
    //     icon: 'videocam',
    //     link: 'secure-live-videos',
    //     permission: LIVE_STREAM_ACCESS.harvest_fetch,
    // },
    // {
    //     id: 'reels',
    //     title: 'Reels',
    //     type: 'basic',
    //     icon: 'photo_camera',
    //     link: 'reels',
    //     permission: REELS.creatorsList,
    // },
    // {
    //     id: 'webinar-unigo',
    //     title: 'Webinar Unigo',
    //     type: 'basic',
    //     icon: 'language',
    //     link: 'webinar-unigo',
    //     permission: WEBINAR_UNIGO.list,
    // },
];

const studioRoutes: FuseNavigationItem[] = [
    {
        id: 'studio-list',
        title: 'Studios List',
        type: 'basic',
        icon: 'article',
        link: 'studio-list',
        permission: STUDIO_ACCESS.list,
    },
    {
        id: 'studio-locations',
        title: 'Studio Locations',
        type: 'basic',
        icon: 'location_on',
        link: 'studio-locations',
        permission: STUDIO_LOCATIONS.list,
    },
    {
        id: 'studio-app-update',
        title: 'Studio App Update',
        type: 'basic',
        icon: 'article',
        link: 'studio-app-update',
        permission: STUDIO_ACCESS.appVersionList,
    },
    {
        id: 'studio-live',
        title: 'Studio Secure Live',
        type: 'basic',
        icon: 'live_tv',
        link: 'studio-live',
        permission: LIVE_STREAM_ACCESS.fetch,
    },
    {
        id: 'studio-yt',
        title: 'Studio Youtube',
        type: 'basic',
        icon: 'article',
        link: 'studio-yt',
        permission: STUDIO_ACCESS.yt,
    },
    {
        id: 'teacherx-lectures',
        title: 'All TeacherX Lectures',
        type: 'basic',
        icon: 'heroicons_outline:user-remove',
        link: 'teacherx-lectures',
        permission: STUDIO_ACCESS.allLectures,
    },
    {
        id: 'classroomx-lectures',
        title: 'All ClassroomX Lectures',
        type: 'basic',
        icon: 'heroicons_outline:user-remove',
        link: 'classroomx-lectures',
        permission: STUDIO_ACCESS.allLectures,
    },
];

const ottRoutes: FuseNavigationItem[] = [
    {
        id: 'ott-subscriptions',
        title: 'OTT Subscription',
        type: 'basic',
        icon: 'paid',
        link: 'ott-subscriptions',
        permission: OTT_SUBSCRIPTION.planList,
    },
    {
        id: 'ott-browse',
        title: 'OTT Browse',
        type: 'basic',
        icon: 'widgets',
        link: 'ott-browse',
        permission: OTT_BROWSE.list,
    },
    {
        id: 'ott-cms-video',
        title: 'OTT CMS Video',
        type: 'basic',
        icon: 'video_library',
        link: 'ott-cms-video',
        permission: OTT_VIDEO.list,
    },
    {
        id: 'ott-cms-playlist',
        title: 'OTT CMS Playlist',
        type: 'basic',
        icon: 'playlist_add',
        link: 'ott-cms-playlist',
        permission: OTT_PLAYLIST.list,
    },
    {
        id: 'ott-cms-teacher',
        title: 'OTT CMS Teacher',
        type: 'basic',
        icon: 'account_circle',
        link: 'ott-cms-teacher',
        permission: OTT_TEACHER.list,
    },
    {
        id: 'ott-cms-job-update',
        title: 'OTT CMS Job Update',
        type: 'basic',
        icon: 'work',
        link: 'ott-cms-job-update',
        permission: OTT_BULK_UPLOAD.jobList,
    },
];

const feedRoutes: FuseNavigationItem[] = [
    {
        id: 'feed-tags',
        title: 'Feed Tags',
        type: 'basic',
        icon: 'article',
        link: 'feed-tags',
        permission: FEEDS_ACCESS.list,
    },
    {
        id: 'feeds',
        title: 'Feeds',
        type: 'basic',
        icon: 'feed',
        link: 'feeds',
        permission: FEEDS_ACCESS.list,
    },
];

const booksRoutes: FuseNavigationItem[] = [
    {
        id: 'exam',
        title: 'Exam',
        type: 'basic',
        icon: 'edit_note',
        link: 'exam',
        permission: EXAM_ACCESS.list,
    },
    {
        id: 'category',
        title: 'Category',
        type: 'basic',
        icon: 'format_align_left',
        link: 'category',
        permission: BOOK_CATEGORY_ACCESS.list,
    },
    {
        id: 'author',
        title: 'Author',
        type: 'basic',
        icon: 'local_library',
        link: 'author',
        permission: AUTHOR_ACCESS.list,
    },
    {
        id: 'publication',
        title: 'Publication',
        type: 'basic',
        icon: 'cloud_done',
        link: 'publication',
        permission: PUBLICATION_ACCESS.list,
    },
    {
        id: 'book-tags',
        title: 'Book Tags',
        type: 'basic',
        icon: 'auto_stories',
        link: 'book-tags',
        permission: BOOK_TAGS_ACCESS.list,
    },
    {
        id: 'delivery-pincodes',
        title: 'Delivery Pin Code',
        type: 'basic',
        icon: 'add_location',
        link: 'delivery-pincodes',
        permission: DELIVERY_PIN_CODE_ACCESS.list,
    },
    {
        id: 'books',
        title: 'Books',
        type: 'basic',
        icon: 'menu_book',
        link: 'books',
        permission: BOOK_ACCESS.list,
    },
];

const promotions: FuseNavigationItem[] = [
    {
        id: 'news-and-blogs',
        title: 'News and Blogs',
        type: 'basic',
        icon: 'list_alt',
        link: 'news-and-blogs',
        permission: NEWS_AND_BLOGS_ACCESS.list,
    },
    {
        id: 'job-alerts',
        title: 'Job Alerts',
        type: 'basic',
        icon: 'work',
        link: 'job-alerts',
        permission: JOB_ALERT.list,
    },
    {
        id: 'referearn',
        title: 'Refer & Earn',
        type: 'basic',
        icon: 'payments',
        link: 'referearn',
        permission: ORGANIZATION_PREFERENCE_ACCESS.refer_list,
    },
    {
        id: 'reward',
        title: 'Rewards',
        type: 'basic',
        icon: 'military_tech',
        link: 'reward',
        permission: REWARD.list,
    },
    {
        id: 'coupons',
        title: 'Coupons',
        type: 'basic',
        icon: 'description',
        link: 'coupons',
        permission: COUPON_ACCESS.list,
    },
    {
        id: 'bulk-coupons',
        title: 'Bulk Coupons',
        type: 'basic',
        icon: 'summarize',
        link: 'bulk-coupons',
        permission: BULK_COUPON_ACCESS.list,
    },
];

const offlineCentreRoutes: FuseNavigationItem[] = [
    {
        id: 'offline-center',
        title: 'Centre Page Management',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: 'offline-center',
        permission: OFFLINE_CATEGORY.listOfflineVerticals,
    },
    {
        id: 'offline-centres',
        title: 'Offline Centres',
        type: 'basic',
        icon: 'cloud_off',
        link: 'offline-centres',
        permission: PATHSHALA_CENTER_ACCESS.list,
    },
    {
        id: 'centre-machine',
        title: 'RFID Machine',
        type: 'basic',
        icon: 'personal_video',
        link: 'centre-machine',
        permission: RFID_MACHINE_ACCESS.list,
    },
    {
        id: 'centre-home',
        title: 'Centre Home',
        type: 'basic',
        icon: 'ads_click',
        link: 'centre-home',
        permission: WEB_PREFERENCE_ACCESS.list,
    },
    {
        id: 'eval-dashboard',
        title: 'Eval Dashboard',
        type: 'basic',
        icon: 'dashboard',
        link: 'eval-dashboard',
        permission: EVAL_DASHBOARD_ACCESS.list,
    },
    {
        id: 'scholarshipTest',
        title: 'Scholarship Test',
        type: 'basic',
        icon: 'stars',
        link: 'scholarship-test',
        permission: SCHOLARSHIP_ACCESS.list,
    },
    {
        id: 'sat-management',
        title: 'SAT Management',
        type: 'basic',
        icon: 'hotel_class',
        link: 'sat-management',
        permission: SAT_CATAGORY.list,
    },
    {
        id: 'webinar-video-category',
        title: 'Webinar Video Category',
        type: 'basic',
        icon: 'subscriptions',
        link: 'webinar-video-category',
        permission: WEBINAR_ACCESS.list,
    },
];

const sstRoutes: FuseNavigationItem[] = [
    {
        id: 'report-tag',
        title: 'Report Tags',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: 'report-tag',
        permission: REPORT_TAGS_ACCESS.list,
    },
    {
        id: 'helpcenter',
        title: 'Help Center',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-pie',
        permission: HELPCENTER_ACCESS.get_chat_flow_tree,
        children: [
            {
                id: 'helpcenter-preferences',
                title: 'Preferences',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: 'helpcenter-preferences',
            },
            {
                id: 'helpcenter-chat-flow-online',
                title: 'Online Paid Flow',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: 'helpcenter-chat-flow/online-paid',
            },
            {
                id: 'helpcenter-chat-flow-online',
                title: 'Online Free Flow',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: 'helpcenter-chat-flow/online-free',
            },
            {
                id: 'helpcenter-chat-flow-online',
                title: 'Online No Batch Flow',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: 'helpcenter-chat-flow/online-no-batch',
            },
            {
                id: 'helpcenter-chat-flow-online',
                title: 'Offline Flow',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: 'helpcenter-chat-flow/offline',
            },
        ],
    },
    {
        id: 'source-flows',
        title: 'Source',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: 'source-flows',
        permission: SOURCE_FLOWS_ACCESS.list,
    },
    {
        id: 'user-groups',
        title: 'User Groups',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: 'user-groups',
        permission: USER_GROUPS_ACCESS.list,
    },
    {
        id: 'notices',
        title: 'Notices',
        type: 'basic',
        icon: 'inventory',
        link: 'notices',
        permission: NOTICE_ACCESS.list,
    },
];

const engagementRoutes: FuseNavigationItem[] = [
    // {
    //     id: 'study-material',
    //     title: 'Study Material',
    //     type: 'basic',
    //     icon: 'study_material',
    //     link: 'study-material',
    //     permission: STUDY_MATERIAL_ACCESS.list,
    // },
    // {
    //     id: 'coach-marks',
    //     title: 'Coach Marks',
    //     type: 'basic',
    //     icon: 'flag',
    //     link: 'coach-marks',
    //     permission: COACH_MARK.coachMark,
    // },
    // {
    //     id: 'battleground',
    //     title: 'Battleground',
    //     type: 'basic',
    //     icon: 'local_dining',
    //     link: 'battleground',
    //     permission: BATTLEGROUND_ACCESS.list,
    // },
    {
        id: 'community',
        title: 'Community',
        type: 'basic',
        icon: 'community_side',
        link: 'community',
        permission: COMMUNITY_ACCESS.list,
    },
    // {
    //     id: 'library',
    //     title: 'Library',
    //     type: 'basic',
    //     icon: 'menu_book',
    //     link: 'library',
    //     permission: LIBRARY_REVAMP_ACCESS.list,
    // },
    // {
    //     id: 'level-up',
    //     title: 'Level Up',
    //     type: 'basic',
    //     icon: 'moving',
    //     link: 'level-up',
    //     permission: LEVEL_UP_ACCESS.getSegments,
    // },
    // {
    //     id: 'NCERT',
    //     title: 'AI NCERT',
    //     type: 'basic',
    //     icon: 'menu_book',
    //     link: 'ai-ncert',
    //     permission: AI_NCERT_ACCESS.bookList,
    // },
    // {
    //     id: 'sahayak',
    //     title: 'Sahayak',
    //     type: 'basic',
    //     icon: 'support',
    //     link: 'sahayak',
    // },
];

const loanBuddiesRoutes: FuseNavigationItem[] = [
    {
        id: 'loan-buddies',
        title: 'Loan buddies',
        type: 'basic',
        icon: 'credit_score',
        link: 'loan-buddies',
        permission: LOAN_BUDDY.applicantList,
    },
    {
        id: 'banks-offers',
        title: 'Banks Offer',
        type: 'basic',
        icon: 'real_estate_agent',
        link: 'banks-offers',
        permission: BANK.list,
    },
];

const externalRoutes: FuseNavigationItem[] = [
    {
        id: 'sdui-service',
        title: 'SDUI',
        type: 'basic',
        icon: 'touch_app',
        function: (item: FuseNavigationItem) =>
            EXTERNAL_NAVIGATION('sdui-service'),
        permission: SDUI_ACCESS.list,
    },
    {
        id: 'multi-batch',
        title: 'Multi Batch',
        type: 'basic',
        icon: 'content_paste',
        function: (item: FuseNavigationItem) =>
            EXTERNAL_NAVIGATION('multi-batch'),
        permission: BATCH_MULTI_ACCESS.list,
    },
    {
        id: 'nuggets-lib',
        title: 'Nuggets Library',
        type: 'basic',
        icon: 'widgets',
        function: (item: FuseNavigationItem) =>
            EXTERNAL_NAVIGATION('nuggets-lib'),
        permission: NUGGETS_ACCESS.list,
    },
    {
        id: 'experience-lib',
        title: 'Nuggets Experience Library',
        type: 'basic',
        icon: 'app_registration',
        function: (item: FuseNavigationItem) =>
            EXTERNAL_NAVIGATION('experience-lib'),
        permission: NUGGETS_ACCESS.listExperience,
    },
    {
        id: 'icons-lib',
        title: 'Nuggets Icons Library',
        type: 'basic',
        icon: 'mood',
        function: (item: FuseNavigationItem) =>
            EXTERNAL_NAVIGATION('icons-lib'),
        permission: NUGGETS_ACCESS.listIcons,
    },
    {
        id: 'pwtalk-nuggets-lib',
        title: 'PW Talk Nuggets Library',
        type: 'basic',
        icon: 'library_books',
        function: (item: FuseNavigationItem) =>
            EXTERNAL_NAVIGATION('pwtalk-nuggets-lib'),
        permission: PW_TALK_ACCESS.nuggetList,
    },
    {
        id: 'pwtalk-modules-lib',
        title: 'PW Talk Modules Library',
        type: 'basic',
        icon: 'menu_book',
        function: (item: FuseNavigationItem) =>
            EXTERNAL_NAVIGATION('pwtalk-modules-lib'),
        permission: PW_TALK_ACCESS.moduleList,
    },
];

const lessonRoutes: FuseNavigationItem[] = [
    {
        id: 'lesson-list',
        title: 'Lesson List',
        type: 'basic',
        icon: 'menu_book',
        link: '/lesson/list',
        permission: 'all',
    },
];
export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'configuration',
        title: 'Configuration',
        type: 'collapsable',
        icon: 'engineering',
        children: configurationRoutes,
    },
    {
        id: 'users',
        title: 'Users',
        type: 'collapsable',
        icon: 'heroicons_outline:users',
        children: userRoutes,
    },
    {
        id: 'application',
        title: 'Application',
        type: 'collapsable',
        icon: 'apps',
        hidden: () => isYcmouMentor(),
        children: applicationRoutes,
    },
    {
        id: 'management',
        title: 'Management',
        type: 'collapsable',
        icon: 'inventory',
        hidden: () => isYcmouMentor(),
        children: managementRoutes,
    },
    {
        id: 'cohort',
        title: 'All Cohorts',
        type: 'collapsable',
        icon: 'school',
        hidden: () => isYcmouMentor(),
        children: cohortRoutes,
    },
    // {
    //     id: 'batch-automation',
    //     title: 'Batch Automation',
    //     type: 'collapsable',
    //     icon: 'brightness_auto',
    //     children: batchAutomationRoutes,
    // },
    // {
    //     id: 'video-player',
    //     title: 'Video Player',
    //     type: 'collapsable',
    //     icon: 'subscriptions',
    //     children: videoPlayerRoutes,

    // },
    {
        id: 'videos',
        title: 'Videos',
        type: 'collapsable',
        icon: 'play_circle',
        hidden: () => isYcmouMentor(),
        children: videosRoutes,
    },
    // {
    //     id: 'studio',
    //     title: 'Studio',
    //     type: 'collapsable',
    //     icon: 'play_circle',
    //     children: studioRoutes,
    // },
    // {
    //     id: 'ott',
    //     title: 'OTT',
    //     type: 'collapsable',
    //     icon: 'podcasts',
    //     link: 'ott',
    //     children: ottRoutes,
    // },
    {
        id: 'feeds',
        title: 'Feeds',
        type: 'collapsable',
        icon: 'feed',
        hidden: () => isYcmouOrg(),
        children: feedRoutes,
    },
    // {
    //     id: 'books',
    //     title: 'Books',
    //     type: 'collapsable',
    //     icon: 'menu_book',
    //     children: booksRoutes,
    // },
    // {
    //     id: 'promotions',
    //     title: 'Promotions',
    //     type: 'collapsable',
    //     icon: 'confirmation_number',
    //     children: promotions,
    // },
    // {
    //     id: 'offline-centre',
    //     title: 'Offline Centre',
    //     type: 'collapsable',
    //     icon: 'school',
    //     children: offlineCentreRoutes,
    // },
    // {
    //     id: 'SST',
    //     title: 'SST',
    //     type: 'collapsable',
    //     icon: 'heroicons_outline:chart-pie',
    //     children: sstRoutes,
    // },
    {
        id: 'Engagement',
        title: 'Engagement',
        type: 'collapsable',
        icon: 'local_bar',
        hidden: () => isYcmouMentor(),
        children: engagementRoutes,
    },
    // {
    //     id: 'Loan Buddies',
    //     title: 'Loan Buddies',
    //     type: 'collapsable',
    //     icon: 'account_balance',
    //     children: loanBuddiesRoutes,
    // },
    // {
    //     id: 'External',
    //     title: 'External',
    //     type: 'collapsable',
    //     icon: 'ios_share',
    //     children: externalRoutes,
    // },
    // {
    //     id: 'jobs',
    //     title: 'Jobs',
    //     type: 'collapsable',
    //     icon: 'school',
    //     children: jobRoutes,
    // },
    {
        id: 'lessons',
        title: 'Lesson Creation',
        type: 'basic',
        icon: 'menu_book',
        link: '/lesson/list',
        permission: 'all',
    },
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];

export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];

export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
